// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3u6bb","col":"styles_col__MyKPS"};